const FIFTEEN_MINUTES_IN_S = 15 * 60;
const DEFAULT_EXPIRES = FIFTEEN_MINUTES_IN_S;

export const isFresh = signedUrl => {
    return signedUrl
        && signedUrl.expiryDate instanceof Date
        && (signedUrl.expiryDate - new Date())/1000 > FIFTEEN_MINUTES_IN_S / 2;
}

export const getAwsS3SignedUrl = ({ bucket, key, expires=DEFAULT_EXPIRES}) => {
    if (!key) return Promise.reject('getAwsS3SignedUrl needs a key');
    if (!bucket) {
        const keyParts = key.split('/');
        bucket = keyParts.shift();
        key = keyParts.join('/');
    }
    if (!bucket || !key) return Promise.reject(`getAwsS3SignedUrl has invalid params: bucket=${bucket}, key=${key}`);
    const s3 = new window.AWS.S3();
    return new Promise(function(resolve, reject) {
        const expiryDate = new Date();
        expiryDate.setSeconds(expiryDate.getSeconds() + expires);
        s3.getSignedUrl('getObject', { Bucket: bucket, Key: key, Expires: expires }, (err, url) => {
            if(err) reject(err);
            else resolve({ url, expiryDate });
        });
    });
}

